module.exports = "<p style=\"font-size:12px;color:#787878;margin-top:4px\">\n    This article has obtained authorization for reposting, copyright belongs to __author_name__, visit yuanben.io and search 【<a\n    href=\"__reproduction_url__\" target=\"_blank\" style=\"text-decoration:none;color:#007f69\">__short_id__</a>】 to verify authorization.</p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/services/badge/badge-reproduction-text-en.html
// module id = 1204
// module chunks = 3